import React, { useEffect, useState } from "react";
import { Container, Spinner, Center } from "@chakra-ui/react";
import PropTypes from "prop-types";
import { getTemplate } from "../api/shortcodeTemplateApi";
import FormPreview from "./FormPreview";
import { defaultTemplates } from "../components/ChooseTemplate/defaultTemplates.json";
const Shortcode = ({ id, displayTitle, displayDesc, apiConfig }) => {
  const [template, setTemplate] = useState(null);
  useEffect(() => {
    getTemplate(id, apiConfig)
      .then((template) => {
        console.log(template);
        setTemplate(() => ({ ...template }));
      })
      .catch((err) => {
        if (id.includes("default")) {
          const template = defaultTemplates.find(
            (template) => id == template.id
          );
          setTemplate(() => ({ ...template }));
        }
        throw err;
      });
  }, []);
  return (
    <Container maxW="container.md" m="2rem auto">
      {template ? (
        <FormPreview
          template={template}
          apiConfig={apiConfig}
          displayTitle={displayTitle}
          displayDesc={displayDesc}
        />
      ) : (
        <Center h="50vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      )}
    </Container>
  );
};

export default Shortcode;

Shortcode.propTypes = {
  id: PropTypes.string.isRequired,
  apiConfig: PropTypes.object.isRequired,
};
